import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DateUtil } from 'src/app/lib/date-util';
import { StringUtil } from 'src/app/lib/string-util';
import { FormElementViewModel, IFormElementViewModel, IFormElementViewModelOptions } from '../forms';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss']
})
export class FormInputComponent implements OnInit {

  @Input() text: string = '';
  validationErrors: string[] = [];

  @Input() vm: IFormInputViewModel;

  @Output() textChanged = new EventEmitter<IFormInputTextChangedArg>();
  @Output() textEntered = new EventEmitter<IFormInputTextChangedArg>();

  @ViewChild('input') inputElement: ElementRef;

  /// todo... add via view model / input
  inputAutocomplete: string = 'off';

  /**
   *
   */
  constructor() { }

  /**
   *
   * @param e
   */
  modelChanged(e) {
    if (!this.vm)
      return;

    const parsedData = this.vm.type == 'number' ? Number.parseInt(e) : this.vm.type == 'number-float' ? Number.parseFloat(e) : e; 
    
    this.vm.dataSet(parsedData);
    this.text = e;

    this.validationErrors = this.vm.validate(this.vm);

    this.textChanged.emit({
      sender: this, errors: this.validationErrors, text: e, viewModel: this.vm,
      number: this.vm.type == 'number' ? Number.parseInt(e) : this.vm.type == 'number-float' ? Number.parseFloat(e) : undefined
    });
  }

  /**
   *
   * @param e
   */
  keyUpEntered(e) {
    if (!this.vm)
      return;

    this.textEntered.emit({
      sender: this, errors: this.validationErrors, text: e, viewModel: this.vm,
      number: this.vm.type == 'number' ? Number.parseInt(e) : this.vm.type == 'number-float' ? Number.parseFloat(e) : undefined
    });
  }

  keyDown(e) {
    if (this.vm.type != 'number-text')
      return;

    const isValidKey = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Control', 'Shift', 'Tab', 'Home', 'End'].find(k => k == e.key) ? true : false;
    if (!isValidKey) {
      e.preventDefault();
    }
      
  }

  /**
   *
   */
  ngOnInit() {
    if (!this.vm) {
      this.validationErrors = ['no view model'];
      return;
    }

    this.text = this.text || this.vm.dataGet();
    this.validationErrors = this.vm.validate(this.vm);
  }

  focus() {
    this.inputElement.nativeElement.focus();
  }

  /**
   *
   */
  ngOnChanges() {
    if (!this.vm)
      return;
    this.validationErrors = this.vm.validate(this.vm);
  }


  /**
   * 
   * @param context 
   * @param field 
   * @param options
   * @param elementInstance 
   * @returns 
   */
  public static viewModel(context: any, field: string, options: IFormInputOptions, elementInstance: number = undefined): IFormInputViewModel {      
    const type: string = options?.type ?? 'text';

    const baseInput = FormElementViewModel.create(context, field, options, elementInstance);

    const ret: IFormInputViewModel = {
      ...baseInput,

      context: context,
      type: type,
      htmlType: type == 'number-float' ? 'number' : type == 'number-text' ? 'text' : type,

      dataSet: type != 'number-text' ? baseInput.dataSet
        : (v) => {
          const numValue = Number.parseFloat((v ?? '0').replaceAll(',', ''));
          context[field] = numValue;
        },
      dataGet: type != 'number-text' ? baseInput.dataGet
        : () => {
          const numberValue = Number.parseFloat((context[field] ?? '0')).toFixed(2).toString();
          return numberValue;
        },

      validate: (vm: IFormInputViewModel) => {
        const errors: string[] = [];
        
        const fieldValue: string = context[field] ?? '';

        if (vm.changeValidator) {
          const v = vm.changeValidator(fieldValue);
          if (v)
            errors.push(v);
        }
        
        if (vm.isRequired && fieldValue === '')
          errors.push('Required');    
        
        if (vm.type == 'number' || vm.type == 'number-float' || vm.type == 'number-text' ) {
          const numValue: number = Number.parseFloat(fieldValue);
          FormInputComponent.validateNumber(numValue, options, errors);

        } else if (vm.type == 'email') {
          if (!StringUtil.validateEmailFormat(fieldValue))
            errors.push('Invalid email format');

        } else {    
          if ((vm.minLength ?? 0) > 0 && fieldValue.length < vm.minLength)
            errors.push(`Min length '${vm.minLength}'`);                
        }

        return errors.filter(e => e);
      }
    };

    return ret;
  }

  /**
   * 
   * @param numValue 
   * @param options 
   * @param errors 
   */
  private static validateNumber(numValue: number, options: IFormInputOptions, errors: string[]) {
    if (isNaN(numValue))
      errors.push('Number required');
    if (options.numberOptions && (numValue < options.numberOptions.min || (options.numberOptions.max !== undefined && numValue > options.numberOptions.max))) {
      
      if (options.numberOptions.max != undefined)
        errors.push(`Number must be between '${options.numberOptions.min}' and '${options.numberOptions.max}'`);
      else 
        errors.push(`Number must be greater than '${options.numberOptions.min}'`);
    }          
  }

}

/**
 *
 */
export interface IFormInputTextChangedArg {
  sender: FormInputComponent;
  errors: string[];

  text: string;
  number?: number;

  viewModel: IFormInputViewModel;
}

/**
 * 
 */
export interface IFormInputViewModel extends IFormElementViewModel, IFormInputOptions {
  context: any;
  htmlType: string;
}

/**
 * 
 */
export interface IFormInputOptions extends IFormElementViewModelOptions {
  minLength?: number;

  type?: string;

  numberOptions?: { min: number, max?: number };
}

